import React from "react";

const initials = (name) =>
  (name || "")
    .split(" ")
    .map((n) => n[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

// Reusable avatar: shows the user's photo if present, otherwise their initials.
export default function Avatar({ name, src, className = "", textClassName = "" }) {
  if (src) {
    return (
      <img
        src={src}
        alt={name || "User"}
        className={`object-cover ${className}`}
      />
    );
  }
  return (
    <span className={`flex items-center justify-center ${className} ${textClassName}`}>
      {initials(name)}
    </span>
  );
}
